import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';

import promise from 'redux-promise';
import multi from 'redux-multi';
import thunk from 'redux-thunk';

import AuthOrApp from './main/authOrApp';
import reducers from './main/reducers';
import { unregister } from './serviceWorker';
import socketService from './services/socketService';

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const domains = window.location.hostname.split('.');

const store = applyMiddleware(multi, thunk, promise)(createStore)(reducers, devTools);
store.dispatch({
  type: 'SET_SUBDOMAIN',
  subdomain: domains[0] === 'www' ? domains[1] : domains[0],
});

// Disponibilizar a store globalmente para uso em actions e serviços
window.store = store;

// Iniciar o serviço de WebSocket após o carregamento completo da página
window.addEventListener('load', () => {
  socketService.connect();
});

ReactDOM.render(
  <Provider store={store}>
    <AuthOrApp />
  </Provider>,
  document.getElementById('app'),
);

// registerServiceWorker()
unregister();
